import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDashboard } from "../../constants";
import { TopSellingCategory } from "../../dashboard.types";

export const requestTopSellingCategories = async (): Promise<
  TopSellingCategory[]
> => {
  return await instance.get(buildUrl(ApiRoutesDashboard.TopSellingCategories));
};
